import { render, staticRenderFns } from "./LookFile.vue?vue&type=template&id=518f8e99&scoped=true"
import script from "./LookFile.vue?vue&type=script&lang=js"
export * from "./LookFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f8e99",
  null
  
)

export default component.exports